import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Moped: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m60 330h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m390 180h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m638.58 538.09-143.72-358.09h-29.86v-30h40c6.13 0 11.64 3.73 13.92 9.41l136.33 339.66c6.17 15.38-1.29 32.84-16.67 39.02z' />
    <path d='m645 630c-57.9 0-105-47.1-105-105s47.1-105 105-105 105 47.1 105 105-47.1 105-105 105zm0-180c-41.36 0-75 33.65-75 75s33.64 75 75 75 75-33.65 75-75-33.64-75-75-75z' />
    <path d='m183 630c-59 0-107-45.76-107-102 0-8.28 6.72-15 15-15s15 6.72 15 15c0 39.7 34.54 72 77 72s77-32.3 77-72c0-8.28 6.72-15 15-15s15 6.72 15 15c0 56.24-48 102-107 102z' />
    <path d='m550 540h-521v-15c-.01-30.33 8.93-58.72 25.87-82.1 15.66-21.61 38.12-38.96 65.12-50.33v-66.57h30v69.93c0 10.3-6.16 19.4-15.69 23.2-42.8 17.05-69.28 49.69-74.4 90.87h490.09v30z' />
    <path d='m360.79 479.8-50.56-149.8h-175.23v-30h186c6.44 0 12.15 4.11 14.21 10.2l44.41 131.58c5.3 15.7-3.13 32.72-18.83 38.02z' />
  </IconBase>
));

Moped.displayName = 'Moped';

export default Moped;
